/**
 * 首页
 * 2017-12-6
 */
"use strict";
angular.module("homeInformationModule", ["homeInformationRouter"]).
controller("homeInformationCtrl", ["$scope", "httpService", "$sce", '$filter', '$stateParams', function($scope, httpService, $sce, $filter, $stateParams) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.status = {

        };
        $scope.listData = [];
        $scope.page = {
            "CURRPAGE": 0,
            "PAGESIZE": 10,
            "ITEMCOUNT": 0
        };
        $scope.params = {
            id: $stateParams.id
        };
    }
    /**
     * [initStatus description] 初始化数据
     */
    function initData() {
        requestData();
    }
    /**
     * [requestData description] 初始化列表数据
     */
    function requestData() {

        $scope.loadingPromise = httpService.http("/mcnww/web/notice/findById.do", $scope.params, "get").then(function(data) {
            $scope.listData = data.data;
            $scope.listData.noticeContent = $sce.trustAsHtml($scope.listData.noticeContent);
        });
    }
    /**
     * [pageChanged description]分页请求
     * @return {[type]} [description]
     */
    $scope.pageChanged = function() {
        $scope.params.currPage = $scope.page.CURRPAGE;
        // $scope.status.jumpToPageNum = $scope.page.CURRPAGE;
        requestData();
        gotoTop();
    };
    /**
     * [gotoTop description点击分页后，回到头部]
     * @return {[type]} [description]
     */
    function gotoTop() {
        $('html, body').animate({ scrollTop: 0 }, 'nomal');
    }
}]);